/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconKnifeFork: {
  name: 'knife_fork';
  data: string;
} = {
  name: 'knife_fork',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m348.778 317.738 49.228-52.001c20.957 9.031 44.068 8.705 60.943-8.169L596.54 119.979l-26.433-26.43-95.936 100.64-18.095-17.25 96.349-101.072-19.812-19.812-98.442 103.268-18.095-17.25L514.93 38.372l-18.913-18.913-137.59 137.59c-17.567 17.567-18.059 39.583-9.425 59.685l-51.806 49.428L46.641 15.638c-77.018 82.207 69.037 273.138 202.723 296.16L20.42 530.234c-14.246 53.167 12.867 79.399 65.339 65.338l216.199-228.377 189.581 228.822c54.431 14.583 82.555-12.623 67.775-67.77L348.778 317.738z"/></svg>`,
};
